import { render, staticRenderFns } from "./lazyImage.vue?vue&type=template&id=20d6b9b2&scoped=true"
import script from "./lazyImage.vue?vue&type=script&lang=js"
export * from "./lazyImage.vue?vue&type=script&lang=js"
import style0 from "./lazyImage.vue?vue&type=style&index=0&id=20d6b9b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d6b9b2",
  null
  
)

export default component.exports